module.exports = __webpack_public_path__ + "img/AL.160de32b.svg";